<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="result_pop">
    <RadioGroup v-model="operateStyle">
      <Radio label="0">
        <span>按选中结果</span>
      </Radio>
      <Radio label="1">
        <span>按搜索结果</span>
      </Radio>
    </RadioGroup>
    <div style="display: flex; align-items: center;margin-top:20px" v-if="reasonFlag">
      <font color="red">*</font>删除原因：
      <RadioGroup @on-change="reasonChange" v-model="deleteReasonFlag">
        <Radio label="0">
          <span>无效信息</span>
        </Radio>
        <Radio label="1">
          <span>重复信息</span>
        </Radio>
        <Radio label="2">
          <span>恶意骚扰</span>
        </Radio>
        <Radio label="3">
          <span>其他原因</span>
        </Radio>
      </RadioGroup>

    </div>
    <Input v-model="deleteReason" v-show="deleteReasonFlag == '3'" type="textarea" style="margin-top:10px"/>
    <div style="text-align: end;margin-top:10px">
      <Button type="primary" class="submit_btn" @click="onOk()">确认</Button>
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
    </div>
  </Modal>
</template>

<script>
    export default {
        name: "OrderOperatePop",
        props: {
          showTitlePop:Boolean,
          menuCode:String,
        },
        data(){
          return {
            title:'删除提示',
            model:false,
            operateStyle:'0',
            deleteReason:'',
            deleteReasonFlag:'',
            reasonFlag:false,
          }
        },
        methods:{
          cancel:function(){
            this.$emit("closeOrderPop",false);
            this.deleteReason = "";
            this.reasonFlag = false;
            this.deleteReasonFlag = '';
          },
          onOk:function () {
            if(this.menuCode != 'b_d-4' && this.menuCode != 'b_d' && !this.deleteReason){
              this.$alert("删除原因不能为空", '提示', {
              confirmButtonText: '确定'
            });
              return;
            }

            this.$emit("closeOrderPop",true,this.operateStyle,this.menuCode,this.deleteReason);
            this.deleteReason = "";
            this.reasonFlag = false;
            this.deleteReasonFlag = '';
          },
          reasonChange:function(value){
            this.deleteReasonFlag = value;
            if(value == '0'){
              this.deleteReason = "无效信息";
            }else if(value == '1'){
              this.deleteReason = "重复信息";
            }else if(value == '2'){
              this.deleteReason = "恶意骚扰";
            }else if(value == '3'){
              this.deleteReason = "";
            }
          }
        },
        watch:{
          showTitlePop:function () {
            this.model=this.showTitlePop;
            this.operateStyle = '0';
            if(this.menuCode == 'b_d-3' || this.menuCode == 'b_d'){
              this.title = "批量还原工单";
              this.reasonFlag = false;
            }else{
              this.title = "批量删除工单";
              if(this.menuCode != 'b_d-4' && this.menuCode != 'b_d'){
                this.reasonFlag = true;
              }else{
                this.reasonFlag = false;
              }
            }
          }
        }
    }
</script>

<style scoped>
.result_pop  .ivu-modal-content{
    height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/OrderOperatePop.vue